import { Modal } from "flowbite-react";
import FormUpdateProduct from "../form/FormUpdateProduct";

type Props = {
    productId: string;
    onClose: () => void;
    onSave: () => void;
};

export default function UpdateProductModal({ productId, onClose, onSave }: Props) {
    return (
        <Modal
            className='relative text-black'
            show={true}
            size="5xl"
            onClose={onClose}
        >
            <Modal.Header>
                <h2 className="text-black">Editar Produto</h2>
            </Modal.Header>
            <Modal.Body className='text-black dark:text-black'>
                <FormUpdateProduct
                    productId={productId}
                    onClose={onClose}
                    onSave={onSave}
                />
            </Modal.Body>
        </Modal>
    );
}